import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  Button, Dropdown, Input, Menu,
} from 'antd';
import { DownOutlined, CheckOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import { useProductContext } from '../../../context/products';
import { IconListFilter } from '../Icon';
import SearchContent from './Search';

export default function HeaderContent(): React.ReactNode | null {
  const { data = [], loading } = useProductContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState<string | null>(null);

  useEffect(() => {
    const match = location.pathname.match(/^\/product\/([^/]+)/);

    if (match) {
      setSelectedKey(match[1]);
    } else {
      setSelectedKey(null);
    }
  }, [location.pathname]);

  const handleMenuClick = ({ key }: { key: string }) => {
    const selectedProduct = data?.find((p) => p.id === key);
    const encodedName = encodeURIComponent(selectedProduct?.name ?? '');

    navigate(`/product/${key}/${encodedName}`);
  };

  const menu = (
    <Menu selectedKeys={selectedKey ? [selectedKey] : []} onClick={handleMenuClick}>
      {data?.map((product) => (
        <Menu.Item key={product.id}>
          <div className={styles.item}>
            {product.name}
            {selectedKey === product.id && (
              <CheckOutlined style={{ color: '#1F3847', marginLeft: 'auto' }} />
            )}
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className={styles.wrapper} style={location.pathname === '/' ? { height: 193 } : { height: 280 }}>
      <div className={styles.content}>
        <NavLink to="/" className="logo">
          <img src="/logo-inverse.svg" alt="logo" />
          <span>Help portal</span>
        </NavLink>
        <div className={styles.menuRight}>
          <Dropdown overlay={menu} placement="bottomRight">
            <Button className={styles.btn} type="text">
              Products
              {' '}
              <DownOutlined />
            </Button>
          </Dropdown>
          <Button className={styles.btn} type="text" onClick={() => navigate('/bookmarks')}>
            Bookmarks
          </Button>
        </div>
      </div>
      {location.pathname !== '/' && (
        <SearchContent />
      )}
    </div>
  );
}
